import React from "react";
import {
    AreaChart,
    Area,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from "recharts";
import { getColor } from "./chart-colors";
import { formatValue } from "./format-value";

const ChartArea = ({ spec, data, height = 300 }) => {
    const { xAxis, series = [], formatting } = spec;
    const valueType = formatting?.valueType;

    return (
        <ResponsiveContainer width="100%" height={height}>
            <AreaChart data={data} margin={{ top: 5, right: 20, left: 0, bottom: 5 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                <XAxis dataKey={xAxis?.key} tick={{ fontSize: 12 }} />
                <YAxis tick={{ fontSize: 12 }} tickFormatter={(v) => formatValue(v, valueType)} />
                <Tooltip formatter={(v, name) => [formatValue(v, valueType), name]} />
                <Legend />
                {series.map((s, i) => (
                    <Area
                        key={s.key}
                        type="monotone"
                        dataKey={s.key}
                        name={s.label}
                        stroke={s.color || getColor(i)}
                        fill={s.color || getColor(i)}
                        fillOpacity={0.2}
                        stackId={s.stackId}
                    />
                ))}
            </AreaChart>
        </ResponsiveContainer>
    );
};

export default ChartArea;
